<template>
  <div class="accessoryUpload">
    <div class="title">会前准备</div>
    <div class="hint">
      <div class="text">*匹配码</div>
    </div>
    <div class="hint">
      <el-input v-model="this.submitObj.clueCode" placeholder="" class="input"></el-input>
    </div>
    <div class="hint">
      <div class="text">*附件上传</div>
    </div>
    <div class="upload">
      <el-upload
        class="upload-demo"
        action
        :http-request="uploadFile"
        ref="upload"
        :limit="fileLimit"
        :on-remove="handleRemove"
        :file-list="fileList"
        :on-exceed="handleExceed"
        :before-upload="beforeUpload"
        list-type="text"
      >
        <el-button class="btn"
          ><i class="el-icon-upload2" style="margin-right: 6px"></i>附件上传</el-button
        >
      </el-upload>
    </div>

    <div class="submit_box">
      <div class="submit" @click="submit">提交</div>
    </div>
  </div>
</template>
<script>
import { uploadAdminH5, updateClueAccessory } from '../../../api/businessCenter'
export default {
  components: {},
  data() {
    return {
      //提交传的参数
      submitObj: {
        clueCode: '', // 线索编号
        prepare: '3', // 会前准备(1：会前准备；2：已通知；3：已有链接)
        prepareUrl: '' // 准备地址
      },
      enterpriseName: '', // 公司名字
      //上传后的文件列表
      fileList: [],
      // 允许的文件类型
      fileType: ['pdf', 'doc', 'docx', 'xls', 'xlsx', 'txt', 'png', 'jpg', 'bmp', 'jpeg'],
      // 运行上传文件大小，单位 M
      fileSize: 50,
      // 附件数量限制
      fileLimit: 1,
      // 附件长路径
      fileListFileLook: []
    }
  },
  methods: {
    //上传文件之前
    beforeUpload(file) {
      // // console.log(file)
      // if (file.type != '' || file.type != null || file.type != undefined) {
      //   //截取文件的后缀，判断文件类型
      //   const FileExt = file.name.replace(/.+\./, '').toLowerCase()
      //   // console.log(FileExt)
      //   //计算文件的大小
      //   const isLt5M = file.size / 1024 / 1024 < 50 //这里做文件大小限制
      //   //如果大于50M
      //   if (!isLt5M) {
      //     this.$message('上传文件大小不能超过 50MB!')
      //     return false
      //   }
      //   //如果文件类型不在允许上传的范围内
      //   if (this.fileType.includes(FileExt)) {
      //     return true
      //   } else {
      //     this.$message.error('上传文件格式不正确!')
      //     return false
      //   }
      // }
    },
    //上传了的文件给移除的事件，由于我没有用到默认的展示，所以没有用到
    handleRemove(file) {
      let i = this.fileList.indexOf(file)
      this.fileList.splice(i, 1) // 删除上传的文件
      this.fileListFileLook.splice(i, 1) // 删除长路径的文件
    },

    //超出文件个数的回调
    handleExceed() {
      this.$message({
        type: 'warning',
        message: '最多上传一个附件'
      })
      return
    },
    //上传文件的事件
    async uploadFile(item) {
      //上传文件的需要formdata类型;所以要转
      let FormDatas = new FormData()
      FormDatas.append('files', item.file)
      const { data: res } = await uploadAdminH5(FormDatas)
      if (res.resultCode == 200) {
        this.fileList.push(item.file) //成功过后手动将文件添加到展示列表里
        this.fileListFileLook.push(res.data.fileLook[0])
      }
    },
    //上传成功后的回调
    handleSuccess() {},
    // 上传附件
    async submit() {
      if (this.fileListFileLook.length == 0) {
        return this.$message({
          type: 'warning',
          message: '请选择上传的附件'
        })
      } else {
        this.submitObj.prepareUrl = this.fileListFileLook[0] // 准备地址
        const { data: res } = await updateClueAccessory(this.submitObj)
        if (res.resultCode == 200) {
          this.$message.success('提交成功')
        } else {
          this.$message.error('匹配码错误，请重新输入！')
        }
      }
    }
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {}
}
</script>
<style scoped lang="less">
.accessoryUpload {
  display: flex;
  flex-direction: column;

  .title {
    color: #151515;
    font-size: 16px;
    font-weight: 500;
    width: 100%;
    display: flex;
    justify-content: center;
    padding-top: 110px;
    padding-bottom: 53px;
  }
  .hint {
    width: 100%;
    display: flex;
    justify-content: center;
    font-size: 14px;
    color: #333333;
    margin-bottom: 16px;
    .text {
      width: 277px;
    }
  }
  .input {
    width: 277px !important;
  }
  .upload {
    display: flex;
    justify-content: center;
    .btn {
      width: 277px;
      background-color: rgba(23, 117, 122, 0.1) !important;
    }
  }

  .submit_box {
    width: 100%;
    display: flex;
    justify-content: center;
    margin-top: 91px;
    .submit {
      width: 145px;
      height: 40px;
      background-color: #17757a;
      color: #fff;
      font-size: 14px;
      border-radius: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}
/deep/.el-upload-list__item {
  max-width: 277px;
}
</style>
